<template>
  <div class="main">
    <!-- 客户案例 -->
    <div class="case" ref="div1">
      <div>
        <div class="title">K12客户案例</div>
        <div class="content">
          <div class="hasImg" v-for="item of list1" :key="item.img">
            <img :src="item.img" alt="" />
            <span class="headline">{{ item.title }}</span>
            <!-- <span class="headline">国家级虚拟仿真实验项目</span> -->
            <span class="desc">{{ item.desc }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="case" ref="div2">
      <div>
        <div class="title" style="margin-top: 12px">其他行业客户案例</div>
        <div class="content">
          <div class="hasImg" v-for="item of list2" :key="item.img">
            <img :src="item.img" alt="" />
            <span class="headline">{{ item.title }}</span>
            <!-- <span class="headline">国家级虚拟仿真实验项目</span> -->
            <span class="desc">{{ item.desc }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list1: [
        {
          title: '北京朝阳实验小学',
          desc:
            'VR未来课堂将虚拟现实技术与实际教学知识点紧密结合，打造与实际教育教学高度集合的高仿真、沉浸式、可交互的解决方案，推展学习空间，提高学习兴趣，增强学习主动探究能力、创造力',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/eg/5.jpg'
        },
        {
          title: '北京清华大学附属中学',
          desc:
            '智慧宫是一款基于 5G 6DOF VR 模拟物、化、生实验场景，提供规范的实验内容、自由化交互， 结合学科实验设计的一套符合课程标准、考试要求的实验课程，该产品既能教学、也能考核。不仅解决了传统实验中遇到的高危操作、实验准备周期长、实验室不足等一系列问题，而且还能够进行批量考核',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/eg/6.jpg'
        },
        {
          title: '青岛市崂山区沙子口小学',
          desc:
            '覆盖中小学语文、英语、科学、物理、化学、生物、地理、历史、安全、国学、心理等内容，跨平台使用，支持老师备课、课程管理、设备监督，推动学校教育信息化建设，促进教育资源共享，推动教育资源均衡',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/eg/1.jpg'
        }
      ],
      list2: [
        {
          title: '安徽省某市智慧党建',
          desc:
            '通过VR以沉浸式、互动性的体验学习，让历史书本中的图画和文字“活起来”让党员更加深切感悟党的艰辛历程，凝心聚力，锤炼党性提高素养，以沉浸、互动的体验学习党建工作智慧化',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/eg/2.jpg'
        },
        {
          title: '海南省南海博物馆',
          desc:
            '利用AR/VR技术手段，打破传统博物馆局限性，是大大的扩展博物馆的延伸空间，最大限度的拓展博物馆功能，满足社会大众的多层次多方位需求的有效途径',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/eg/3.jpg'
        },
        {
          title: '中石油网上展馆',
          desc:
            '利用虚拟现实技术把用户想要展 示的内容通过网上展馆进行展览展 示。不受时间，空间的限制。实现 永不落幕的展览优势',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/eg/4.jpg'
        }
      ],
      ref: ''
    };
  },
  created() {
    this.ref = this.$route.query.id;
  },
  mounted() {
    this.goAnchor(this.ref);
  },
  methods: {
    goAnchor(selector) {
      var anchor = this.$refs[selector]; //获取元素
      this.$nextTick(() => {
        anchor.scrollIntoView();
      });
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  .case {
    width: 100%;
    background: #fff;
    > div {
      width: 1200px;
      height: 691px;
      margin: 0 auto;
      padding-top: 1px;
      .title {
        font-size: 42px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.6);
        line-height: 1;
        text-align: center;
        margin-top: 48px;
      }
      .content {
        width: 100%;
        display: flex;
        margin-top: 49px;
        .hasImg {
          width: 33.3%;
          height: 100%;
          box-sizing: border-box;
          padding: 0 30px;
          padding-bottom: 10px;
          &:nth-child(2) {
            border-right: 1px solid #dadada;
            border-left: 1px solid #dadada;
          }
          img {
            width: 100%;
            height: 200px;
          }
          .headline {
            margin-top: 40px;
            line-height: 1;
            font-size: 28px;
            font-weight: bold;
            color: #9fa1b4;
            display: block;
            &:nth-of-type(2) {
              margin-top: 10px;
            }
          }
          .desc {
            display: block;
            font-size: 18px;
            font-weight: 400;
            color: #9fa1b4;
            line-height: 24px;
            margin-top: 20px;
          }
        }
        .noImg {
          width: 33.3%;
          height: 100%;
          > div {
            width: 100%;
            padding: 15px;
            box-sizing: border-box;
            &:last-child {
              border-top: 1px solid #dadada;
            }
            .headline {
              font-size: 28px;
              font-weight: bold;
              color: #9fa1b4;
              line-height: 40px;
              min-height: 92px;
            }
            .desc {
              font-size: 18px;
              font-weight: 400;
              color: #9fa1b4;
              line-height: 24px;
              margin-top: 20px;
            }
          }
        }
      }
      .more {
        margin-top: 64px;
        display: flex;
        justify-content: center;
        span {
          font-size: 24px;
          color: #9fa1b4;
          line-height: 1;
        }
        img {
          width: 22px;
          height: 18px;
        }
      }
    }
  }
}
@media (max-width: 1000px) {
  .main .case{
    > div{
      width: 100%;
      height: auto;
      .title{
        margin-top: 80px;
        font-size: 44px;
        color: #5E5E5E;
        letter-spacing: 0;
        text-align: center;
        font-weight: 500;
      }
      .content{
        margin-top: 80px;
        display: block;
        padding: 1px 48px;
        .hasImg:nth-child(n){
          width: 100%;
          padding: 0;
          margin-bottom: 100px;
          border: none;
          img{
            width: 100%;
            height: 386px;
          }
          .headline{
            font-size: 36px;
            color: #8D8E9D;
            letter-spacing: 0;
            font-weight: 500;
            margin-top: 28px;
          }
          .desc{
            font-size: 28px;
            color: #8D8E9D;
            letter-spacing: 0;
            font-weight: 400;
            line-height: 1.3;
          }
        }
      }
    }
  }
}
</style>
